import PageableBase from 'app/collections/pageable_base';
import { appUrl } from 'utils/wrappers';
import Insurance from 'app/models/insurance';

export default PageableBase.extend({
  model: Insurance,
  key: 'insurances',
  url: appUrl('insurances'),

  initialize(models, { apiModeSelection, dateRange }) {
    this.apiModeSelection = apiModeSelection;
    this.dateRange = dateRange;

    this.listenTo(this.dateRange, 'change', this.resetToFirstPage);
    this.listenTo(this.apiModeSelection, 'change', this.resetToFirstPage);
  },

  paramsForFetch() {
    return {
      ...this.apiModeSelection.getParams(),
      ...this.dateRange.getParams(),
    };
  },
});



// WEBPACK FOOTER //
// ./app/collections/insurances.js